import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/companies/:creatorId']['GET'];

type Input = {
  creatorId: string;
  page: number;
  perPage?: number;
  search?: string;
};

type Output = ThisApi['response'];

const getCompanies = async ({ creatorId, page, perPage, search }: Input): Promise<Output> => {
  const response = await noodleApiClient.get(`/companies/${creatorId}`, {
    params: {
      page,
      perPage,
      search,
    },
  });

  return response.data;
};

export default getCompanies;
